/*global naver*/
import React, { useState, useEffect } from "react";

let mapInstance = null;

const Location = ({ latitude = 37.24853832334571, longitude = 127.0569114754529 }) => {
    const [isMapLoaded, setMapLoaded] = useState(false);

    const initMap = () => {
        // 네이버 지도 API와 map DOM이 모두 준비됐는지 확인
        if (
            typeof window.naver === "undefined" ||
            typeof window.naver.maps === "undefined" ||
            !document.getElementById("map")
        ) {
            return;
        }

        const mapOptions = {
            zoomControl: false,
            zoomable: false,
            scrollWheel: false,
            pinchZoom: false,
            disableDoubleClickZoom: true,
            draggable: false,
            center: new naver.maps.LatLng(latitude, longitude),
            zoom: 18,
        };

        mapInstance = new naver.maps.Map("map", mapOptions);

        const marker = new naver.maps.Marker({
            position: new naver.maps.LatLng(latitude, longitude),
            map: mapInstance,
        });

        naver.maps.Event.addListener(marker, "click", () => {
            mapInstance?.setCenter(new naver.maps.LatLng(latitude, longitude));
            mapInstance?.setZoom(16);
        });

        setMapLoaded(true);
    };

    useEffect(() => {
        // 네이버 지도 API가 로드될 때까지 대기
        const timer = setInterval(() => {
            if (
                typeof window.naver !== "undefined" &&
                typeof window.naver.maps !== "undefined" &&
                document.getElementById("map")
            ) {
                clearInterval(timer);
                initMap();
            }
        }, 100);

        return () => clearInterval(timer);
    }, [latitude, longitude]);

    return (
        <div>
            <div
                id="map"
                style={{
                    width: "100%",
                    height: "600px",
                    border: "1px solid #f1f1f1",
                }}
            ></div>
        </div>
    );
};

export default Location;
